import { render, staticRenderFns } from "./dutyquestion.vue?vue&type=template&id=2830efa3&scoped=true&"
import script from "./dutyquestion.vue?vue&type=script&lang=js&"
export * from "./dutyquestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2830efa3",
  null
  
)

export default component.exports